/**
 * Проставляет уровень опасности
 * @param ac
 */
function setAc(ac) {
    let po = ifField.getByName('master_character_danger');
    po.setText(ac)
}

function formatDanger(t) {
    let a = t.val();
    "0.125" === a || "0,125" === a || "1.8" === a || "1,8" === a || "1-8" === a ? a = "1/8" : "0.25" === a || "0,25" === a || "1.4" === a || "1,4" === a || "1-4" === a ? a = "1/4" : "0.5" !== a && "0,5" !== a && "1.2" !== a && "1,2" !== a && "1-2" !== a || (a = "1/2"), t.val(a)
}

function setValueCustom(t) {
    //$("#master_character_danger").val(t.attr("data-danger"))
}

function EncounterPlanner_onChange() {
    countSteps();
    countDifficulty();
    showFactors();
    highlightDifficulty();
}

function clearAll() {
    $("#pc,#mc,#advisable").html("");
    $('.part input[type="text"]').val("");

    EncounterPlanner_onChange();
}

function addRow(type) {
    if ("player" === type) {
        addPlayer();
    } else {
        addMaster();
    }

    EncounterPlanner_onChange();
    findAdvisable();
}

function removeRow(row) {
    row.remove();

    EncounterPlanner_onChange();
    findAdvisable();
}

function addPlayer() {
    $(".player").each(function () {
        let row = $(this);
        row.removeClass("input_error");
        let level = row.val();
        if ("" === level || level < 1 || level > 20) {
            row.addClass("input_error");
        }
    });

    if ($(".player.input_error").length > 0) {
        return;
    }

    const PCcount = $("#player_character_count").val();
    const PClevel = $("#player_character_level").val();
    const PCcountCaption = numEnding(PCcount, ["персонаж", "персонажа", "персонажей"]);
    const html = `<li count="${PCcount}" level="${PClevel}"><strong>${PCcount}</strong> ${PCcountCaption} <strong>${PClevel}-го</strong> уровня<span title="Удалить" onclick="removeRow($(this).parent());">×</span></li>`;
    $("#pc").append(html);
}

function addMaster() {
    $(".master").each(function () {
        let row = $(this);
        let value = row.val();
        if ("" === value) {
            row.addClass("input_error");
            return;
        }

        if ("master_character_danger" === $(this).attr("id") && !(value in danger)) {
            row.addClass("input_error");
            return;
        }

        if ("master_character_count" === $(this).attr("id") && (value < 1 || value > 20)) {
            row.addClass("input_error");
            return;
        }

        $(this).removeClass("input_error");
    });

    if ($(".master.input_error").length > 0) {
        return;
    }

    let count = $("#master_character_count").val();
    let CR = $("#master_character_danger").val();
    let row = '<li count="' + count + '" danger="' + CR + '"><strong>' + count + "</strong> «" + $("#master_character").val() + '»</strong><span title="Удалить" onclick="removeRow($(this).parent());">×</span></li>';
    $("#mc").append(row);
}

const ENCOUNTER_EASY = 0;
const ENCOUNTER_MEDIUM = 1;
const ENCOUNTER_HARD = 2;
const ENCOUNTER_DEADLY = 3;

let xpThresholdsByLevel = {
        1: [25, 50, 75, 100],
        2: [50, 100, 150, 200],
        3: [75, 150, 225, 400],
        4: [125, 250, 375, 500],
        5: [250, 500, 750, 1100],
        6: [300, 600, 900, 1400],
        7: [350, 750, 1100, 1700],
        8: [450, 900, 1400, 2100],
        9: [550, 1100, 1600, 2400],
        10: [600, 1200, 1900, 2800],
        11: [800, 1600, 2400, 3600],
        12: [1e3, 2e3, 3e3, 4500],
        13: [1100, 2200, 3400, 5100],
        14: [1250, 2500, 3800, 5700],
        15: [1400, 2800, 4300, 6400],
        16: [1600, 3200, 4800, 7200],
        17: [2e3, 3900, 5900, 8800],
        18: [2100, 4200, 6300, 9500],
        19: [2400, 4900, 7300, 10900],
        20: [2800, 5700, 8500, 12700]
    };

let difficultyThresholds = [0, 0, 0, 0];
let playerTotal = 0;
let masterTotal = 0;
let difficulty = 0;
let factorId;
let totalExp;
let multiplier = [
        "Маленький отряд. Битвы усложняются.",
        "Стандартный отряд. Нет факторов отряда",
        "Большой отряд. Битвы упрощаются."
];
let factor = [.5, 1, 1.5, 2, 2.5, 3, 4, 5];


function countSteps() {
    playerTotal = 0;
    difficultyThresholds = [0, 0, 0, 0];

    $("#pc li").each(function () {
        let characterCount = parseInt($(this).attr("count"));
        let characterLevel = parseInt($(this).attr("level"));

        difficultyThresholds[ENCOUNTER_EASY]   += characterCount * xpThresholdsByLevel[characterLevel][ENCOUNTER_EASY];
        difficultyThresholds[ENCOUNTER_MEDIUM] += characterCount * xpThresholdsByLevel[characterLevel][ENCOUNTER_MEDIUM];
        difficultyThresholds[ENCOUNTER_HARD]   += characterCount * xpThresholdsByLevel[characterLevel][ENCOUNTER_HARD];
        difficultyThresholds[ENCOUNTER_DEADLY] += characterCount * xpThresholdsByLevel[characterLevel][ENCOUNTER_DEADLY];

        playerTotal += characterCount;
    });

    difficultyThresholds.forEach(function (xp, idx) {
        $("#steps div:eq(" + idx + ") span").text(xp)
    });
}


function countDifficulty() {
    difficulty = 0;
    masterTotal = 0;
    totalExp = 0;
    $("#mc li").each(function () {
        var CR = $(this).attr("danger");
        let NPCcount = parseInt($(this).attr("count"));
        masterTotal += NPCcount;
        totalExp += parseInt(danger[CR]) * NPCcount;
    });
    factorId = 1;
    factorId = masterTotal < 2
                    ? 1 :
                2 === masterTotal
                    ? 2 :
                masterTotal > 2 && masterTotal < 7
                    ? 3 :
                masterTotal > 6 && masterTotal < 11
                    ? 4 :
                masterTotal > 10 && masterTotal < 15
                    ? 5
                    : 6;
    playerTotal > 0 && playerTotal < 3 ? factorId++ : playerTotal > 5 && factorId--
}

function showFactors() {
    var t = "";
    0 === playerTotal
        ? t += "" :
        playerTotal > 0 && playerTotal < 3
            ? t += multiplier[0] :
        playerTotal > 2 && playerTotal < 6
            ? t += multiplier[1] :
        playerTotal > 5 && (t += multiplier[2]);

    "" !== t && (t += "<br>");

    t += 0 === masterTotal
            ? "" :
        1 === masterTotal
            ? "Один противник. Нет фактора количества противников." :
        2 === masterTotal
            ? "Несколько противников. Множитель сложности <strong>×1.5</strong>" :
        masterTotal > 2 && masterTotal < 7
            ? "Несколько противников. Множитель сложности <strong>×2</strong>" :
        masterTotal > 6 && masterTotal < 11
            ? "Много противников. Множитель сложности <strong>×2.5</strong>" :
        masterTotal > 10 && masterTotal < 15
            ? "Много противников. Множитель сложности <strong>×3</strong>"
            : "Очень много противников. Множитель сложности <strong>×4</strong>";

    0 !== masterTotal && (t += "<br>");

    "" !== t && (t += "Итоговый множитель сложности: <strong>×" + factor[factorId] + "</strong><br>");
    masterTotal > 0 && (t += "Итоговая сложность боевой сцены: <strong>" + totalExp * factor[factorId] + "</strong><br>");

    masterTotal > 0 && playerTotal > 0 && (t += "Каждый персонаж получит по <strong>" + Math.round(totalExp / playerTotal) + "</strong> опыта");

    "" !== t
        ? $("#factor").html(t)
        : $("#factor").html("Добавьте персонажей мастера.")
}

function highlightDifficulty() {
    $("#steps>div").removeClass("active");
    let totalXP = totalExp * factor[factorId];
    if (totalXP <= 0 || playerTotal < 1) {
        return;
    }
    difficulty = totalXP < difficultyThresholds[ENCOUNTER_MEDIUM]
                        ? ENCOUNTER_EASY :
                totalXP < difficultyThresholds[ENCOUNTER_HARD]
                        ? ENCOUNTER_MEDIUM :
                totalXP < difficultyThresholds[ENCOUNTER_DEADLY]
                        ? ENCOUNTER_HARD
                        : ENCOUNTER_DEADLY;

    $("#steps>div:eq(" + difficulty + ")").addClass("active");
}

function findAdvisable() {
    if (0 === difficultyThresholds[ENCOUNTER_MEDIUM] || 0 === difficultyThresholds[ENCOUNTER_HARD]) {
        return;
    }

    let minXP = Math.round(.8 * difficultyThresholds[ENCOUNTER_MEDIUM]);
    let maxXP = Math.round(1.2 * difficultyThresholds[ENCOUNTER_HARD]);

    $.ajax({
        url: "/request/encounter_difficulty_recomendations/",
        type: "post",
        dataType: "html",
        data: {
                min: minXP,
                max: maxXP,
                players: playerTotal
        },
        success: function (t) {
            $("#advisable").html(t)
        }
    });
}